"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$articleGroupHeadLine = void 0;
const factory_1 = __importDefault(require("../factory"));
const _sentenceChildren_1 = __importDefault(require("./$sentenceChildren"));
const _articleGroupNum_1 = __importDefault(require("./$articleGroupNum"));
const _indents_1 = __importDefault(require("./$indents"));
const line_1 = require("../../../node/cst/line");
const lexical_1 = require("./lexical");
const util_1 = require("../util");
const helpers_1 = require("../../../law/std/helpers");
const inline_1 = require("../../../node/cst/inline");
const makeRangesRule_1 = __importDefault(require("./makeRangesRule"));
const controls_1 = require("../../../node/el/controls");
const { $ranges: $articleGroupRanges } = (0, makeRangesRule_1.default)(() => _articleGroupNum_1.default);
/**
 * The parser rule for {@link ArticleGroupHeadLine} that represents a head line of a head line of an article group (e.g. "Chapter"). Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/cst/rules/$articleGroupHeadLine.spec.ts) for examples.
 */
exports.$articleGroupHeadLine = factory_1.default
    .withName("articleGroupHeadLine")
    .sequence(s => s
    .and(() => _indents_1.default, "indentsStruct")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .and(r => r
    .sequence(s => s
    .and(r => r.regExp(/^:keep-indents:/), "value")
    .action(({ value, range }) => ({ value, range: range() }))), "control")
    .and(r => r
    .sequence(s => s
    .and(() => lexical_1.$_, "value")
    .action(({ value, range }) => ({ value, range: range() }))), "trailingSpace")
    .action(({ control, trailingSpace }) => {
    return new inline_1.Control(control.value, control.range, trailingSpace.value, trailingSpace.range);
}))), "control")
    .and(r => r
    .sequence(s => s
    .and(() => $articleGroupRanges, "ranges")
    .action(({ ranges, text, range }) => ({ ranges, text: text(), range: range() }))), "articleGroupNum")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(c => c
    .and(r => r
    .sequence(c => c
    .and(() => lexical_1.$__, "space")
    .action(({ space, range }) => {
    return { text: space, range: range() };
})), "space")
    .and(() => _sentenceChildren_1.default, "inline")
    .action(({ space, inline }) => {
    return { space, inline };
}))), "tail")
    .and(() => lexical_1.$_EOL, "lineEndText")
    .action(({ range, control, indentsStruct, articleGroupNum, tail, lineEndText }) => {
    const errors = [
        ...indentsStruct.errors,
        ...articleGroupNum.ranges.errors,
        ...(tail?.inline.errors ?? []),
    ];
    const sentenceChildren = (0, util_1.mergeAdjacentTexts)([
        new controls_1.__Text(articleGroupNum.text, articleGroupNum.range),
        ...(tail
            ? [
                new controls_1.__Text(tail.space.text, tail.space.range),
                ...tail.inline.value,
            ]
            : []),
    ]);
    return {
        value: new line_1.ArticleGroupHeadLine({
            range: range(),
            indentTexts: indentsStruct.value.indentTexts,
            mainTag: helpers_1.typeCharsMap[articleGroupNum.ranges.value[0][0].value.typeChar],
            controls: control ? [control] : [],
            sentenceChildren,
            lineEndText,
        }),
        errors,
    };
}));
exports.default = exports.$articleGroupHeadLine;
//# sourceMappingURL=$articleGroupHeadLine.js.map